<!-- <ng-container>
	<div class="item-default" (click)="openUrl(card)" role="button" tabindex="0">
		<ion-img [src]="card?.imageUrl" alt=""></ion-img>
		<div class="info" role="region" aria-label="Information section">
			<h3>{{ card.title }}</h3>
			<p>{{ card.description }}</p>
		</div>
	</div>
</ng-container> -->
<ng-container>
	<div class="item-image" (click)="openUrl(card?.url)" role="button" tabindex="0">
		<ion-img [src]="card?.imageUrl" alt="card news"></ion-img>
		<div class="info" role="region" aria-label="Information section">
			<h3>{{ card.title }}</h3>
			<p>{{ card.description }}</p>
		</div>
	</div>
</ng-container>
